// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74d50f7b","732":"c62236f3"}[chunkId] + ".chunk.js";
};